var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#000"}}),_c('path',{attrs:{"d":"M20.643 19.717h7.046v.776h-7.046v7.368h-.806v-7.368h-6.768v-.776h6.768v-7.383h.806v7.383z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }